import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const LightBulbFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function LightBulbFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M11.68 0h.64C17.11 0 21 3.89 21 8.68c0 1.83-.58 3.62-1.66 5.1l-1.85 2.55c-.33.45-.61.92-.86 1.41L16 19H8l-.63-1.26c-.25-.49-.54-.96-.86-1.41l-1.85-2.55A8.659 8.659 0 0 1 3 8.68C3 3.89 6.89 0 11.68 0ZM15 22v-1H9v1c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default LightBulbFilled;